export default "__VITE_ASSET___4MfnqGz__"